export default {
  save: 'ذخیره',
  closeWithoutSaving: 'بدون ذخیره‌کردن ببند.',
  exitWithoutSave(name: string) {
    return (
      'تغییرات صفحه‌ی ' +
      name +
      ' ذخیره نشده است، آیا مطمئن هستید می‌خواهید این صفحه را ببندید؟'
    );
  },
  cancel: 'لغو',
  edit: 'ویرایش',
  close: 'بستن',
};
